import * as React from 'react';
import { useContext } from 'react';
import { NotationManagementActionType } from '../types/NotationManagementActionType';
import { useSnackbar } from 'notistack';
import { NotationManagementDispatch } from '../NotationManagement';
import { ILowerAlert } from '../Interfaces/ILowerAlert';
import NotationResponseDialog from '../../../../shared-components/Notation/NotationResponseDialog';
import { IAction } from '../../../../shared-interfaces/Notation/IAction';
import { IMethodOfContact } from '../../../../shared-interfaces/Notation/IMethodOfContact';
import ReactGA from 'react-ga';
import AlertService from '../../../../shared-services/Notation/AlertService';
import {
  GetCoreUserFormattedName,
  ICoreUser,
} from '../../../../shared-interfaces/User/ICoreUser';
import { Theme, useMediaQuery } from '@mui/material';

const LowerAlert = (props: ILowerAlert) => {
  const dispatch = useContext(NotationManagementDispatch);
  const { enqueueSnackbar } = useSnackbar();

  const isLessThanSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  return (
    <NotationResponseDialog
      open={props.open}
      close={props.close}
      assignable={false}
      assignedTo={props.assignedTo}
      for={props.for}
      audience={props.audience}
      transition={isLessThanSm}
      notationType="Alert"
      title={`Lower Alert for: ${GetCoreUserFormattedName(props.for, false)}`}
      handleResponse={(
        action: IAction,
        details: string,
        assignedTo?: ICoreUser,
        methodOfContact?: IMethodOfContact,
      ) => {
        return (async () => {
          try {
            const success = await AlertService.lower(
              props.id,
              action.id,
              details,
              methodOfContact?.id,
              assignedTo?.id,
            );
            if (success) {
              dispatch({
                type: NotationManagementActionType.LowerAlerts,
                ids: [props.id],
              });
              if (assignedTo) {
                dispatch({
                  type: NotationManagementActionType.AssignTo,
                  id: props.id,
                  assignTo: assignedTo,
                });
              }
              dispatch({
                type: NotationManagementActionType.CloseModal,
              });
              enqueueSnackbar('Lowered Alert', { variant: 'success' });

              ReactGA.event({
                category: 'NotationManagement',
                action: 'AlertLowered',
              });

              return true;
            } else {
              enqueueSnackbar('Failed to Lower Alert', { variant: 'error' });
              return false;
            }
          } catch {
            enqueueSnackbar('Failed to Lower Alert', { variant: 'error' });
            return false;
          }
        })();
      }}
    />
  );
};

export default LowerAlert;
